import { OnSpotAnswer, OnSpotQuestion } from '@/model/onSpot/OnSpot';
import React from 'react';
import SingleDateInput from '../../../../../comp/form/dateInput/SingleDateInput';
import CurrencyInput from 'react-currency-input-field';

interface AnswerProps {
    question: OnSpotQuestion;
    answer: OnSpotAnswer;
    handleChange: (answer: OnSpotAnswer, value?: string) => void;
    treeSectionId: string;
}

export const Answer = ({ question, answer, handleChange, treeSectionId }: AnswerProps) => {
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target instanceof HTMLInputElement) {
            if (question.type === 'singleChoice') {
                question.answers.forEach((a) => {
                    a.checked = false;
                });
            }
            answer.checked = event.target.checked;
        }

        handleChange(answer, event.target?.value ?? null);
    };

    const handleDateInputChange = (value: string, valid: boolean) => {
        if (valid) {
            handleChange(answer, value);
        }
    };

    /*TODO: is not finished yet - datePicker does not work fine*/
    if (answer.type === 'number') {
        return (
            <label className="label number-selection">
                {answer.numberType === 'currency' && (
                    <CurrencyInput
                        name={answer.label}
                        placeholder="0,00 €"
                        decimalsLimit={2}
                        intlConfig={{ locale: 'de-DE', currency: 'EUR' }}
                        value={answer.value !== '0' ? answer.value : ''}
                        maxLength={7}
                        onValueChange={(value) => {
                            handleChange(answer, value);
                        }}
                    />
                )}
            </label>
        );
    }

    if (question.type === 'input') {
        return (
            <label className="label">
                {answer.type === 'number' && answer.numberType === 'currency' && (
                    <div className="number-selection">
                        <CurrencyInput
                            name={answer.label}
                            placeholder="0,00 €"
                            decimalsLimit={2}
                            intlConfig={{ locale: 'de-DE', currency: 'EUR' }}
                            value={answer.value !== '0' ? answer.value : ''}
                            maxLength={7}
                            onValueChange={(value) => {
                                handleChange(answer, value);
                            }}
                        />
                    </div>
                )}
                {answer.type === 'text' ? (
                    <>
                        {answer.isTextarea ? (
                            <textarea
                                value={answer.value ?? ''}
                                rows={3}
                                id={`answer-${answer.id.toString()}`}
                                placeholder={answer.label}
                                onChange={(e) => handleChange(answer, e.target.value)}
                            />
                        ) : (
                            <input
                                id={`answer-${answer.id.toString()}`}
                                type="text"
                                onChange={(e) => handleChange(answer, e.target.value)}
                                value={answer.value ?? ''}
                            />
                        )}
                    </>
                ) : answer.type === 'date' ? (
                    <>
                        {/*TODO: Komponente grundlegend neu bauen - ein wunder das sie halbwegs funktioniert*/}
                        <SingleDateInput
                            classList="input-field"
                            errorText={'Fehler'}
                            name={answer?.label}
                            value={answer?.value}
                            handleChange={handleDateInputChange}
                            maxDate={new Date()}
                        />
                    </>
                ) : null}
            </label>
        );
    }

    if (question.type === 'singleChoice' || question.type === 'multipleChoice') {
        return (
            <div key={`input-${answer.id}`}>
                <input
                    id={`answer-${treeSectionId}-${answer.id.toString()}`}
                    type={question.type === 'singleChoice' ? 'radio' : 'checkbox'}
                    name={`question-${treeSectionId}-${question.id.toString()}`}
                    value={answer.label}
                    checked={answer.checked ?? false}
                    onChange={handleCheckboxChange}
                />
                <label key={answer.id} htmlFor={`answer-${treeSectionId}-${answer.id.toString()}`} className="chip">
                    <span>{answer.label}</span>
                </label>
            </div>
        );
    }
    return null;
};
export default Answer;
